import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './accordion-element.css';
import LazySrcEvents from '../lazy-src/LazySrcEvents';

export default class AccordionElement extends TemplateElement {
    resizeObserver = null;
    RESIZABLE_ELEMENTS = ['list-filter'];

    constructor() {
        super({ shadowRender: true, styles: [style] });
    }

    connected() {
        if (!this.open) this.collapse();

        if (this.hasAttribute('cloak')) {
            this.removeAttribute('cloak');
        }

        this.reEvaluateHeight = this.reEvaluateHeight || this.RESIZABLE_ELEMENTS.some(el => this.querySelector(el));
        if (this.reEvaluateHeight) {
            this.resizeObserver = new ResizeObserver(entries => {
                const contentHeight = this.$refs.resizableContent.scrollHeight;
                this.$refs.content.style.height = contentHeight + 'px';
            });
        }

        this.querySelectorAll("[cloak='display-none']").forEach(element => element.removeAttribute('cloak'));
    }

    properties() {
        return {
            open: false,
            reEvaluateHeight: false,
        };
    }

    watch() {
        return {
            open: open => {
                open === true ? this.expand() : this.collapse();
                this.setAttribute('open', `${open}`);
            },
        };
    }

    events() {
        return {
            this: {
                [LazySrcEvents.IMG_LOAD]: () => {
                    if (this.open) this.expand();
                },
            },
            '[data-toggle]': {
                click: () => {
                    this.toggle();
                },
            },
        };
    }

    toggle() {
        this.open = !this.open;
    }

    collapse() {
        const contentHeight = this.$refs.content.scrollHeight;

        const elementTransition = this.$refs.content.style.transition;
        this.$refs.content.style.transition = '';

        requestAnimationFrame(() => {
            this.$refs.content.style.height = contentHeight + 'px';
            this.$refs.content.style.transition = elementTransition;

            requestAnimationFrame(() => {
                this.$refs.content.style.height = 0 + 'px';
            });
        });

        this.$refs.content.setAttribute('data-collapsed', 'true');
        this.reEvaluateHeight ? this.resizeObserver?.unobserve(this.$refs.resizableContent) : '';
    }

    expand() {
        const contentHeight = this.$refs.content.scrollHeight;
        this.$refs.content.style.height = contentHeight + 'px';

        this.$refs.content.setAttribute('data-collapsed', 'false');
        this.reEvaluateHeight ? this.resizeObserver?.observe(this.$refs.resizableContent) : '';
    }

    template() {
        return html`
            <div class="title-wrapper flex items-center justify-between hover:cursor-pointer" ref="header" data-toggle>
                <slot name="header"></slot>
            </div>
            <div class="content-wrapper" ref="content">
                <div ref="resizableContent">
                    <slot name="content"></slot>
                </div>
            </div>
        `;
    }
}

defineElement('accordion-element', AccordionElement);
